import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  createBatchTitle: {
    description: 'batchesEpics.createBatchTitle',
    defaultMessage: 'Create New Batch',
    id: 'dFZV2p',
  },
  createBatchErrorMessage: {
    description: 'batchesEpics.createBatchErrorMessage',
    defaultMessage: 'Could not batch at this time. Please try again.',
    id: 'sUZsZ1',
  },
  sendEmailsTitle: {
    description: 'batch.details.sendingShipmentEmailTitle',
    defaultMessage: 'Shipment Notifications',
    id: 'oRRB8h',
  },
  sendEmailsContent: {
    description: 'batch.details.sendingShipmentEmailContent',
    defaultMessage: 'Sending shipment notifications',
    id: 'pNi1pn',
  },
  emailsSentTitle: {
    description: 'batch.details.emailsSentTitle',
    defaultMessage: 'Shipment Notifications Sent',
    id: 's5mizX',
  },
  emailsSentContent: {
    description: 'batch.details.emailsSentContent',
    defaultMessage: 'Shipment notifications were sent successfully',
    id: '95kdRX',
  },
  couldNotLoadGridErrorTitle: {
    description: 'batch.details.failedToLoadGridTitle',
    defaultMessage: 'Failed to Load Batch',
    id: 'JApgeJ',
  },
  couldNotLoadGridErrorBody: {
    description: 'batch.details.failedToLoadGridBody',
    defaultMessage: 'Could not load batch at this time. Please try again.',
    id: 'YSGRf7',
  },
  cancelBatchSuccessTitle: {
    description: 'title of notification for successfully cancelling 1 or more batches',
    defaultMessage: 'Success!',
    id: 'vAePG3',
  },
  cancelBatchSuccessBodySingular: {
    description: 'body of notification for successfully cancelling a batch',
    defaultMessage: 'ShipStation successfully cancelled Batch {batchName}',
    id: 'V4lmuA',
  },
  cancelBatchSuccessBodyMultiple: {
    description: 'body of notification for successfully cancelling a batch',
    defaultMessage: 'ShipStation successfully cancelled {batchCount} Batches',
    id: '72XaVg',
  },
  cancelBatchErrorTitle: {
    description: 'title of notification for error cancelling batch',
    defaultMessage: 'Error',
    id: 'UtN7kG',
  },
  cancelBatchErrorBody: {
    description: 'body of notification for error cancelling batch',
    defaultMessage: 'Failed to cancel batch',
    id: 'pNmi/5',
  },
});
